import { motion } from "framer-motion";
import { SendHorizontal } from "lucide-react";

/** Session ownership and draft clearing stay with the caller. */
export function TranscriptTextInput({
  value,
  onChange,
  onSend,
  disabled,
  placeholder,
  inputClassName,
  buttonClassName,
}: {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  disabled: boolean;
  placeholder: string;
  inputClassName: string;
  buttonClassName: string;
}) {
  return (
    <form
      data-transcript-form
      className="flex min-w-0 flex-1 items-center gap-2"
      onSubmit={(event) => {
        event.preventDefault();
        if (!disabled && value.trim()) onSend();
      }}
    >
      <div className="relative min-w-0 flex-1">
        <input
          data-transcript-input
          type="text"
          aria-label="Message to tutor"
          value={value}
          onChange={(event) => onChange(event.currentTarget.value)}
          placeholder={placeholder}
          className={inputClassName}
          disabled={disabled}
        />
      </div>
      <motion.button
        data-transcript-send
        whileTap={{ scale: 0.93 }}
        type="submit"
        disabled={disabled || value.trim().length === 0}
        className={buttonClassName}
        aria-label="Send message"
        title="Send (Enter)"
      >
        <SendHorizontal size={17} aria-hidden="true" />
      </motion.button>
    </form>
  );
}
